import React from 'react';
import { Certification } from '@axiom/const';
import type { BioRenderableCandidate } from '@axiom/validation';

import { SectionHeader } from '../../content/SectionHeader/SectionHeader';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { ParagraphHeader } from '../../content/ParagraphHeader/ParagraphHeader';
import { QualificationsCertificationsAccomplishmentsUtil } from '../../../utils/qualifications-certifications-accomplishments-util';

const { QUALIFICATION_AWARDS } = Certification;

export type TalentCertificationsTypes = {
  candidate: BioRenderableCandidate;
};

export const TalentCertifications = ({
  candidate,
}: TalentCertificationsTypes) => {
  const awardTypes = Object.values(QUALIFICATION_AWARDS);
  const certifications = (candidate.certifications || []).filter(
    cert => !awardTypes.includes(cert.award)
  );

  return certifications.length > 0 ? (
    <>
      <SectionHeader name="Certifications_Awards">
        Certifications & Awards
      </SectionHeader>
      <Gutter bottom="12px" />
      {certifications.map((cert, index) => {
        const { award, institution, year } = cert;
        const institutionYearText =
          QualificationsCertificationsAccomplishmentsUtil.getInstitutionYearText(
            cert
          );

        return (
          <div
            data-test="CERTIFICATION_AWARD"
            key={`${award}_${institution}_${year}`}
          >
            <ParagraphHeader name="AWARD_NAME">{award}</ParagraphHeader>

            {institutionYearText ? (
              <Paragraph name="INSTITUTION_YEAR" as="span">
                {institutionYearText}
              </Paragraph>
            ) : null}
            {index < certifications.length - 1 && <Gutter bottom="8px" />}
          </div>
        );
      })}
    </>
  ) : null;
};
